
import React from 'react';
import Logo from "@/components/shared/Logo";

const FooterLogo = () => {
  return (
    <div>
      <div className="mb-4">
        <Logo variant="dark" />
      </div>
      <p className="text-white text-sm">
        The pulse of a nation, in real time. Where data meets democracy, and public voice drives progress.
      </p>
    </div>
  );
};

export default FooterLogo;
